import PageWrapper from "components/ui/PageWrapper";
import BlogPostType from "types/BlogPostType";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { BlogPost } from "components/blog/BlogPost";

interface Props {
  post: BlogPostType;
}

function Show({ post }: Props) {
  return (
    <PageWrapper>
      <BlogPost post={post} />
    </PageWrapper>
  );
}

Show.layout = DefaultLayoutWrapper;
export default Show;